import request from '@/service/request'

export default {
  ...request,
  base_url: 'https://staging.api-huaydragon.com/lotto/',
  getURL() {
    return this.base_url
  },
}
